export class PropertyMasterSettingsDTO{
    public propertyId!:number;
    public settings!:string;
}

